import { Component, OnInit, ViewChild, AfterContentInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TransactionService } from '../../../Services/transaction.service';
import { PaymentAgingParam } from "../../../Models/searchCustomer"
import { ContactConsigneeParams, UploadFileData } from '../../../Models/master';
import { OpsDetailParams, SpraAmcvParams, SpraCsaRate, SpraRequestDetail, OpsProductDetail, Ops, SpraApprovalParams, SpraApprovalDetail, SpraApprovalRemarksParams, SpraValidation, PaymentTerm, SPRACompetitionDetailParams, SpraConsigneeData, SpraAmcvTotalValue, DiscountView, PriceRefCalculations } from '../../../Models/ops';
import { OpsPartParams, OpsProduct, ProductSearchParam } from '../../../Models/product';
import { OpsPartSerachComponent } from '../../masters/ops-part-serach/ops-part-serach.component';
import { MatDialog } from '@angular/material/dialog';
import { Utility } from '../../../Utilities/utility';
import { CookieService } from 'ngx-cookie-service';
import { OpsListComponent } from '../../masters/ops-list/ops-list.component';
import { OpsService } from '../../../Services/ops.service';
import { OpsPaymentTermsComponent } from '../../masters/ops-payment-terms/ops-payment-terms.component';
import { SpraApprovalComponent } from '../../masters/spra-approval/spra-approval.component';
import { SpraCompetitionDetailComponent } from '../../masters/spra-competition-detail/spra-competition-detail.component';
import { SpraAmcvComponent } from '../../masters/spra-amcv/spra-amcv.component';
import { SpraNetSalePriceRealisedComponent } from '../../masters/spra-net-sale-price-realised/spra-net-sale-price-realised.component';
import { MasterService } from 'src/app/Services/master.service';
import { NotificationService } from 'src/app/Services/notification.service';
import { SpraPriceJustificationComponent } from '../../masters/spra-price-justification/spra-price-justification.component';
import { SpraApprovalRemarksComponent } from '../../masters/spra-approval-remarks/spra-approval-remarks.component';
import { CustomerAgeingComponent } from '../../masters/customer-ageing/customer-ageing.component';
import { MultipleFileUploadComponent } from '../../masters/multiple-file-upload/multiple-file-upload.component';
import { HttpEventType } from '@angular/common/http';
import { UploadFilesService } from 'src/app/Services/upload.service';
import { SpraConsumableBillingDetailComponent } from '../../masters/spra-consumable-billing-detail/spra-consumable-billing-detail.component';
import { SpraDiscountViewComponent } from '../../masters/spra-discount-view/spra-discount-view.component';
import { SpraViewConsigneeComponent } from '../../masters/spra-view-consignee/spra-view-consignee.component';
import { Observable, forkJoin, of } from 'rxjs';


@Component({
  selector: 'app-spra-request',
  templateUrl: './spra-request.component.html',
  styleUrls: ['./spra-request.component.css']
})

export class SpraRequestComponent implements OnInit, AfterContentInit {
  paymentAgingParam: PaymentAgingParam;
  contactBillingParams: ContactConsigneeParams;
  contactConsigneeParams: ContactConsigneeParams;
  OpsPartParams: OpsPartParams;
  utility: Utility;
  SpraRequestDetail: SpraRequestDetail;
  param: any;
  LinkedOps: Ops;
  ValidTill: string;
  SPRAId: number = 0;
  OpportunityId: number = 0;
  Mode: string = "I";
  IsSalesAdmin: boolean = false;
  IsRequestReviewed: boolean = false;
  IsFromApprovedlist: boolean = false;
  RefSpraDetail: any;
  SPRAPriceRefId: any;
  spraApprovalDetail: SpraApprovalDetail;
  ExistingCsaRate: any[] = [];
  EmployeeId: number = 0;
  PartnerId: number = 0;
  ProfitTag: boolean;
  IsCeha: boolean;
  IsSpraHaveFinishGood: boolean = false;
  @ViewChild(MultipleFileUploadComponent) MultipleFileUploadComponent !: MultipleFileUploadComponent;
  @ViewChild(CustomerAgeingComponent) CustomerAgeingComponent!: CustomerAgeingComponent;
  @ViewChild(OpsPartSerachComponent) opsPartSerachComponent!: OpsPartSerachComponent;
  @ViewChild(OpsPaymentTermsComponent) OpsPaymentTermsComponent!: OpsPaymentTermsComponent;
  @ViewChild(SpraApprovalComponent) SpraApprovalComponent!: SpraApprovalComponent;
  @ViewChild(SpraCompetitionDetailComponent) SpraCompetitionDetailComponent!: SpraCompetitionDetailComponent;
  @ViewChild(SpraNetSalePriceRealisedComponent) SpraNetSalePriceRealisedComponent!: SpraNetSalePriceRealisedComponent;
  @ViewChild(SpraAmcvComponent) SpraAmcvComponent!: SpraAmcvComponent;
  @ViewChild(SpraPriceJustificationComponent) SpraPriceJustificationComponent!: SpraPriceJustificationComponent;
  @ViewChild(SpraApprovalRemarksComponent) SpraApprovalRemarksComponent!: SpraApprovalRemarksComponent;
  @ViewChild(SpraConsumableBillingDetailComponent) SpraConsumableBillingDetailComponent!: SpraConsumableBillingDetailComponent;
  //Added By rahul yadav on 27/05/2021 for discountview
  @ViewChild(SpraDiscountViewComponent) SpraDiscountViewComponent!: SpraDiscountViewComponent;
  @ViewChild(SpraViewConsigneeComponent) SpraViewConsigneeComponent!: SpraViewConsigneeComponent;

  //added by swati on 12/03/2021

  public SPRADetail: any;
  //end of addition by swati
  public DisableSubmit:boolean = false;
  public ShowReviewButton:boolean=false;
  PageFor: any;
  SpraValidationList: any;
  AlreadyApproved: any;
  constructor(private router: Router,
    private _TransactionService: TransactionService,
    private _CookieService: CookieService,
    private _OpsService: OpsService,
    private _MasterService: MasterService,
    private dialog: MatDialog,
    private _NotificationService: NotificationService,
    private uploadService: UploadFilesService
    ,private route: ActivatedRoute
  ) {
    this.utility = new Utility(this._CookieService);
    this.paymentAgingParam = new PaymentAgingParam();
    this.contactBillingParams = new ContactConsigneeParams();
    this.contactConsigneeParams = new ContactConsigneeParams();
    this.OpsPartParams = new OpsPartParams();
    this.SpraRequestDetail = new SpraRequestDetail();
    this.LinkedOps = new Ops();
    this.spraApprovalDetail = new SpraApprovalDetail();
    this.param = this.router.getCurrentNavigation()?.extras.state;
    this.EmployeeId = this.utility.user.employeeId;
    this.ProfitTag = false;
    this.IsCeha = false;
    this.ValidTill = "";
  }

  ngOnInit(): void {

    // this.route.params.subscribe((params) =>{
    //   if(params.SPRAId!=undefined && params.SPRAId!=0){
    //     this.param = params;
    //   }
    // });

  }


  ngAfterContentInit() {

    
    /*---just for testing */
    // this.SpraRequestDetail.RefId = 924193;
    // this.SpraRequestDetail.CompanyId = 80845566;
    // this.SpraRequestDetail.OfficeId = 22
    // this.paymentAgingParam.saleCode = "";
    // // this.PartnerId = 129;   
    // this.SpraRequestDetail.SaleType = 'DL';
    // this.SPRAId = 317;
    //  this.Mode = "U";    
    // this.paymentAgingParam.CompanyId = this.SpraRequestDetail.CompanyId ;
    // this.paymentAgingParam.officeId = this.SpraRequestDetail.OfficeId;
    // // //  this.OpportunityId = 11379
    // // this.ProfitTag = true;
    //  this.IsSalesAdmin = true;
    //Added by rahul yadav on 1/7/2021 to get query string value from mail
   
    if (this.param) {
      debugger
      this.SpraRequestDetail.RefId = parseInt(this.param.RefId);
      this.SpraRequestDetail.CompanyId = parseInt(this.param.CompanyId);
      this.paymentAgingParam.CompanyId = parseInt(this.param.CompanyId);
      this.paymentAgingParam.saleCode = this.param.SaleCode;
      this.SpraRequestDetail.OfficeId = parseInt(this.param.OfficeId);
      this.PartnerId = parseInt(this.param.PartnerId);
      this.paymentAgingParam.officeId = this.SpraRequestDetail.OfficeId;
      this.IsCeha = this.param.IsCeha; //Added by rahul yadav to redirect page to sas or sbs

      if (this.param.SaleType != undefined && this.param.SaleType != "") {
        this.SpraRequestDetail.SaleType = this.param.SaleType;
      } else {
        this.SpraRequestDetail.SaleType = "DD";
      }
      if (this.param.IsSalesAdmin != undefined) {
        this.IsSalesAdmin = this.param.IsSalesAdmin;
      }
      if (this.param.SPRAId != undefined && this.param.SPRAId > 0) {
        this.SPRAId = parseInt(this.param.SPRAId);
        this.Mode = this.param.UpdateTag;
      }
      if (this.param.OpportunityId != undefined && this.param.OpportunityId > 0) {
        this.OpportunityId = this.param.OpportunityId;
       
      }
      //added by rahul yadav on 10/05/2022
      if(this.param.IsFromApprovedlist != undefined){
        this.IsFromApprovedlist = this.param.IsFromApprovedlist;
      }
debugger
      //Added By Sagar Pandey on date 10-09-2025 
      if(this.param.PageFor != undefined){
        this.PageFor = this.param.PageFor;
      }
    }

   


    setTimeout(() => {

      this.SpraApprovalComponent.CompanyId = this.SpraRequestDetail.CompanyId;
      this.CustomerAgeingComponent.BindAgeingDetail();
      this.OpsPaymentTermsComponent.PaymentTermParams.IsForSpra = true;
      this.opsPartSerachComponent.IsTaxApplicable = false;
      this.opsPartSerachComponent.RefId = this.SpraRequestDetail.RefId;
      this.opsPartSerachComponent.BindProductSegment();
      this.opsPartSerachComponent.BindGrade(); //Added by rahul yadav to bind grade
      // this.opsPartSerachComponent.ProfitTag=true;
      if (this.SpraNetSalePriceRealisedComponent != undefined) {
        this.SpraNetSalePriceRealisedComponent.SaleType = this.SpraRequestDetail.SaleType;
        this.SpraNetSalePriceRealisedComponent.DealerParam.OfficeId = this.SpraRequestDetail.OfficeId;
        if (this.Mode == 'I') {
          this.SpraNetSalePriceRealisedComponent.BindDealerList();
        }
      }
      if (this.SpraApprovalComponent != undefined) {
        this.SpraApprovalComponent.SaleType = this.SpraRequestDetail.SaleType;
        this.opsPartSerachComponent.SaleType = this.SpraRequestDetail.SaleType;
      }
      if (this.SpraApprovalRemarksComponent != undefined) {
        this.SpraApprovalRemarksComponent.IsSalesAdmin = this.IsSalesAdmin;
      }
      if (this.MultipleFileUploadComponent != undefined) {
        this.MultipleFileUploadComponent.SpraId = this.SPRAId;
      }
      this.DealerChange(this.PartnerId);
    //Added By Sagar On 21-12-2023 To Set OpportunityId in opsPartSerachComponent so that we can Identify If hit Comming from open enquiry list or not 
      if (this.OpportunityId != undefined && this.OpportunityId > 0) {
        this.opsPartSerachComponent.OpportunityId = this.param.OpportunityId;
      }

    }, 1000);

    if (this.Mode == "U" && this.SPRAId != undefined && this.SPRAId > 0) {
      this.SpraRequestDetail.Id = this.SPRAId;
    
      this.GetSpraRequestData();

    }
    if (this.OpportunityId != undefined && this.OpportunityId > 0) {
      this.SpraRequestDetail.OpportunityId = this.OpportunityId;
      this.BindSpraEnquiryDetail();
      
    }


    this.GetExistingCsaRate();
  }

//Added By Sagar Pandey on Date 10-09-2025 to Check if the request exixts in validation list or not if yes it means it's not validated
  async GetSpraValidationList()
  {
  return this._TransactionService.GetSpraValidationList(this.EmployeeId,this.IsCeha).toPromise().then((d: any) => {
      this.SpraValidationList = d;
      if (this.SpraValidationList != null) {
        this.AlreadyApproved = this.SpraValidationList.filter((x: any) => x.id == this.SPRAId);
      }
  }, (error) => {                              //Error callback
    this.utility.Error(error);
  });
}

//Added By Sagar Pandey on Date 10-09-2025 to Check if the request exixts in validation list or not if yes it means it's not validated
async GetValidationListForAdminSales()
{
return this._TransactionService.GetValidationListForAdminSales(this.IsCeha).toPromise().then((d: any) => {
    this.SpraValidationList = d;
    if (this.SpraValidationList != null) {
      this.AlreadyApproved = this.SpraValidationList.filter((x: any) => x.id == this.SPRAId);
    }
}, (error) => {                              //Error callback
  this.utility.Error(error);
});
}


  // when model value change of OpsDetailComponent for (Dispatch Warehouse and Condignee State);
  changeOpsDetail(opsDetailParams: OpsDetailParams) {
    // this.opsPartSerachComponent.taxApiParam.StateFromId = opsDetailParams.DispatchWareHouseStateId;

  }



  openOpsList(): void {
    const dialogRef = this.dialog.open(OpsListComponent, {
      width: '80%',
      data: { refId: this.SpraRequestDetail.RefId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.FillSpraFromOps(result.data.recordId);
      }
    });
  }


  SaleTypeChange() {
    setTimeout(() => {
      // ADDED BY RAJAN SINGH ON 10 AUG 2021 
      this.opsPartSerachComponent.SaleType = this.SpraRequestDetail.SaleType;
      this.ChangeOpsPartSerach(this.opsPartSerachComponent.ProductSearchParam);
      this.SpraApprovalComponent.SaleType = this.SpraRequestDetail.SaleType;
      this.SpraNetSalePriceRealisedComponent.SaleType = this.SpraRequestDetail.SaleType;
      this.SpraNetSalePriceRealisedComponent.ResetCommission();
      this.SpraAmcvComponent.SaleType = this.SpraRequestDetail.SaleType;
    }, 0);
  }

  ChangeOpsPartSerach(ProductSearchParam: ProductSearchParam) {
    if (this.SpraNetSalePriceRealisedComponent != undefined) {
      this.SpraNetSalePriceRealisedComponent.DealerParam.ProductSegmentId = ProductSearchParam.ProdSegmentId;
    }
    if (ProductSearchParam.ProdSegmentId > 0 && this.SpraRequestDetail.SaleType != "") {
      this.SpraApprovalComponent.BindWarrenty(ProductSearchParam.ProdSegmentId, this.SpraRequestDetail.SaleType, ProductSearchParam.WarrantyMonth);
      if (this.SpraAmcvComponent != undefined) {
        this.SpraAmcvComponent.SpraAmcvParams = [];
      }
      this.SpraApprovalComponent.SpraCsaRateArray = [];
      this.opsPartSerachComponent.TriggerProductModelChange();
      this.IsSpraHaveFinishGood = this.opsPartSerachComponent.GetFinishedGoodsTag();
      this.SpraApprovalComponent.IsSpraHaveFinishGood = this.IsSpraHaveFinishGood;
      this.opsPartSerachComponent.GetFinishedGoodsTotalPrice();

    }

  }

  ProductValueChanged(FinishGoodValue: number) {
    this.IsSpraHaveFinishGood = this.opsPartSerachComponent.GetFinishedGoodsTag();
    this.SpraApprovalComponent.IsSpraHaveFinishGood = this.IsSpraHaveFinishGood;
    if (!this.IsSpraHaveFinishGood) {
      this.SpraApprovalComponent.ResetWarrenty();
    }

    this.SpraApprovalComponent.TotalFgValue = FinishGoodValue;
    this.SpraApprovalComponent.CalculateWarrentyCost();
    this.SetProductQtyToAmcv();

  }

  SetProductQtyToAmcv() {
    if (this.SpraAmcvComponent != undefined) {
      Promise.all(this.SpraAmcvComponent.SpraAmcvParams.map((am) => {
        if(am.ProductList != undefined){
        am.Qty = this.opsPartSerachComponent.productArray.filter((pa) =>
          am.ProductList.indexOf(pa.SelectedProduct?.productId) >= 0
        ).map(mt => mt.Quantity).reduce((sum, current) => sum + current, 0);
        this.SpraAmcvComponent.EmclChange(am);
        }
      }));
    }
  }

  GetFGProduct(FGProdParam: Array<OpsProduct>) {
    // debugger
    // console.log("sdsd");  
    if (this.SpraAmcvComponent != undefined && FGProdParam.length>0 && this.SpraAmcvComponent.SpraAmcvParams.length>0) {
      this.SpraAmcvComponent.AmcvFGProductParams = FGProdParam;
      this.SpraAmcvComponent.CalculateTotalSaleValue();
    }else if(this.DisableSubmit){
      // conditon added by rajan singh -->> To handle Non FG SPRA
      // this.InitializeSpraRequestModal();
    }

  }

  GetAMCVTotalValues(spraAmcvTotalValue: SpraAmcvTotalValue) {
    this.opsPartSerachComponent.spraAmcvTotalValue = spraAmcvTotalValue;
    this.opsPartSerachComponent.CalcFGServTotAmount().then(t=>{
      if(t && this.DisableSubmit){        
        // this.InitializeSpraRequestModal();
      }
    });

    
    // setTimeout(() => {
    //   this.utility.BlockUIStop();
    // }, 1000);

  }


  ChangeSpraApproval(spraApprovalParams: SpraApprovalParams) {
    if (this.SpraAmcvComponent != undefined) {
      this.SpraAmcvComponent.SpraApprovalParams = spraApprovalParams;
      this.SpraAmcvComponent.CalculateA3CopyLoad();


    }
  }


  async ChkDayOneCSA(spraApprovalParams: SpraApprovalParams,FromChangeCounterList:boolean=false) {
    debugger;
    // this.opsPartSerachComponent.TriggerProductModelChange();

    //   this.opsPartSerachComponent.GetDistinctProductCounter();

    //Added By Jamaluddin Ansari on 05/09/2023 for DayOneCSA check/uncheck
    if (this.SpraApprovalComponent.IsDayOneCSAClick ) {
      debugger
      //Added By Sagar Pandey on 22-11-2023 to iterate through productArray not from this.SPRADetail.ProdDetail show that added new product on runtime stay binded even if DayOnceCsa is clicked
      let ModifiedArray = this.opsPartSerachComponent.productArray

      //Added By Sagar Pandey on 11-12-2023 Because If product array length is 1 it means it's empty row 
      //and then if that is empty row it means for loop will not be executed so no need to make it empty 
      if(this.opsPartSerachComponent.productArray.length > 1)
        this.opsPartSerachComponent.productArray = new Array<OpsProduct>();
      
      this.opsPartSerachComponent.Mode = this.Mode;
      this.opsPartSerachComponent.IsDayOneCSAClick = spraApprovalParams.DayOneCSA;
      // Promise.all(this.SPRADetail.ProdDetail.map((element: any, index: number) => {
      for (let index = 0; index < ModifiedArray.length-1; index++) {
        let opsProduct: OpsProduct = new OpsProduct()
        this.opsPartSerachComponent.ProductSearchParam.ProductCode = ModifiedArray[index].SelectedProduct.productCode.replace(/\s+$/g, '');
        this.opsPartSerachComponent.ProductSearchParam.ProductId =  ModifiedArray[index].SelectedProduct.productId;
      //Added By Sagar Pandey To Fetch Sprapricelist from database 
       await this._MasterService.GetSPRAPriceListData(ModifiedArray[index].SelectedProduct.productId,0,this.SpraApprovalComponent.SaleType,0).then((d:any) =>{
          if(d.length>0){        
            let data: any =JSON.parse(d.toString());
            ModifiedArray[index].SelectedProduct.PriceList =  data.PriceList;
            ModifiedArray[index].SelectedProduct.WorkSheetNSP = data.WorkSheetNSP;
            ModifiedArray[index].SelectedProduct.WorkSheetLanded = data.WorkSheetLanded;
            ModifiedArray[index].SelectedProduct.BookingLanded = data.BookingLanded;        
            ModifiedArray[index].PriceList = data.PriceList;
            ModifiedArray[index].BookingLanded = data.BookingLanded;
            ModifiedArray[index].WorkSheetLanded= data.WorkSheetLanded;
            ModifiedArray[index].WorkSheetNSP = data.WorkSheetNSP;
            ModifiedArray[index].UnitWSCost = data.WorkSheetLanded      
          }
          
        });
       
        opsProduct.Price =  ModifiedArray[index].Price;
        opsProduct.Quantity =  ModifiedArray[index].Quantity;
        opsProduct.PriceList =  ModifiedArray[index].SelectedProduct.PriceList;
        opsProduct.WorkSheetLanded =  ModifiedArray[index].SelectedProduct.WorkSheetLanded;
        opsProduct.WorkSheetNSP =  ModifiedArray[index].SelectedProduct.WorkSheetNSP;
        opsProduct.BookingLanded =  ModifiedArray[index].SelectedProduct.BookingLanded;
        opsProduct.IsNewRow = true;
        opsProduct.PId =  ModifiedArray[index].SelectedProduct.productId;
        opsProduct.gID =  ModifiedArray[index].SelectedProduct.gradeId;
        opsProduct.pQty =  ModifiedArray[index].Quantity;
        this.opsPartSerachComponent.productArray.push(opsProduct);
        
        await this.opsPartSerachComponent.BindProductAutocomplete(opsProduct, index, true);
        debugger
        if (index == (ModifiedArray.length-1)-1) { 
          this.opsPartSerachComponent.addRow(opsProduct);
          if (this.SpraViewConsigneeComponent != undefined && this.SPRADetail.ConsigneeDetails != undefined) {
            this.SpraViewConsigneeComponent.ConsineeDetails = this.SPRADetail.ConsigneeDetails;
          }
        }
        // }));
      }
    }
    
    
    if (this.SpraApprovalComponent.IsDayOneCSAClick && FromChangeCounterList == false) {
      this.SpraApprovalComponent.SpraCsaRateArray = [];
      this.opsPartSerachComponent.GetDistinctProductCounter();
    }
    

    this.ChangeSpraApproval(this.SpraApprovalComponent.SpraApprovalParams);
    if (this.SpraApprovalComponent.SpraApprovalParams.DayOneCSA
      && this.SpraApprovalComponent.SpraCsaRateArray.filter((csr) => { return csr.OrderRate != undefined && csr.OrderRate > 0 }).length > 0
    ) {
      debugger      
      this.SpraCompetitionDetailComponent.IsCopetitionCsaRateRequired = true;

    } else if (this.SpraCompetitionDetailComponent != undefined) {
      this.SpraCompetitionDetailComponent.ResetCompCsaRate();
      this.SpraCompetitionDetailComponent.IsCopetitionCsaRateRequired = false;

    }
    if (this.SpraAmcvComponent != undefined && this.ProfitTag == true) {
      this.SpraAmcvComponent.spraCSARate = this.SpraApprovalComponent.SpraCsaRateArray;
      this.SpraAmcvComponent.CalculateTotalSaleValue();
    }

  }


  ChangeCounterList(CounterList: any[]) {
    // && this.Mode=="I"

    //  Removed by rajan singh on 17/06/2021 -- after discussion with Mr. anand 
    // && this.SpraRequestDetail.SaleType != "LL"
    if (CounterList != null && CounterList.length > 0) {

      this.SpraApprovalComponent.IsSpraHaveCopMfd = this.opsPartSerachComponent.GetSpraHaveCopMfdTag();

      // ---Used for AMCV Counter List --- 
      
      //this._MasterService.GetTechnical("technicalcode in ('T08','T10')").toPromise().then((d) => {
      this._MasterService.GetTechnical("TechnicalId in ('7','8','9','10')").toPromise().then((d) => {
        if (d) {
          if (this.SpraAmcvComponent != undefined) {
            this.SpraAmcvComponent.SpraAmcvParams = new Array<SpraAmcvParams>();
            this.SpraAmcvComponent.SaleType = this.SpraRequestDetail.SaleType;
          }

          this.SpraApprovalComponent.SpraCsaRateArray = new Array<SpraCsaRate>();
          let TechnicalList: any[] = [];
          let AmcvCounterWise: any[] = [];
          TechnicalList = TechnicalList.concat(JSON.parse(d.toString()));

          this._MasterService.GetCustomerAmcvCounterWise(this.SpraRequestDetail.CompanyId).toPromise().then((d) => {
            if (d) {
              AmcvCounterWise = AmcvCounterWise.concat(JSON.parse(d.toString()));
            let index:number=0;
            Promise.all(CounterList.map(element => {               

                if (this.SpraApprovalComponent.SpraApprovalParams.DayOneCSA) {

                  if (this.SpraApprovalComponent?.SpraCsaRateArray.filter((sc) => { return sc.CounterId == element.counterId }).length <= 0) {
                    let _SpraCsaRate: SpraCsaRate = new SpraCsaRate();
                    _SpraCsaRate.CounterId = element.counterId;
                    _SpraCsaRate.CounterDesc = element.counterDesc;
                    let ExistingCsaRate: any[] = this.ExistingCsaRate.filter(e => e.CounterId == element.counterId)
                    if (ExistingCsaRate != undefined && ExistingCsaRate.length > 0) {
                      _SpraCsaRate.ExistingCSARate = ExistingCsaRate[0].Rate;
                    }
                    this.SpraApprovalComponent?.SpraCsaRateArray.push(_SpraCsaRate);
                  }

                }


                
                let _SpraAmcvParams: SpraAmcvParams = new SpraAmcvParams();
                // -----------In case of DayOneCSA -- only one row of color counter -----
                if (this.SpraApprovalComponent.SpraApprovalParams.DayOneCSA && this.SpraAmcvComponent?.SpraAmcvParams.filter((ac) => { return ac.CounterId == element.counterId  }).length <= 0 ) {
                  _SpraAmcvParams.TechnicalId = 0;
                  _SpraAmcvParams.CounterId = element.counterId;
                  _SpraAmcvParams.CounterDesc = element.counterDesc;
                  _SpraAmcvParams.ProductList = element.productList;
                  this.UpdateExistingAMCVInCounter(_SpraAmcvParams, AmcvCounterWise);
                  this.SpraAmcvComponent?.SpraAmcvParams.push(_SpraAmcvParams);
                } else {  // logic for color counter -->> show multiple row ()
                  Promise.all(TechnicalList.map(tl => {
                    if (this.SpraAmcvComponent?.SpraAmcvParams.filter((ac) => { return ac.CounterId == element.counterId && ac.TechnicalId == tl.technicalid  }).length <= 0) {
                    _SpraAmcvParams = new SpraAmcvParams();
                    _SpraAmcvParams.ProductList = element.productList;
                    _SpraAmcvParams.CounterId = element.counterId;
                    this.UpdateExistingAMCVInCounter(_SpraAmcvParams, AmcvCounterWise);
                    if ([2, 4].indexOf(element.counterId) >= 0 && tl.technicalcode == 'T10') {
                      _SpraAmcvParams.TechnicalId = tl.technicalid;
                      _SpraAmcvParams.CounterDesc = element.counterDesc + " [" + tl.technicaldesc + "]";

                      this.SpraAmcvComponent?.SpraAmcvParams.push(_SpraAmcvParams);
                    } else if ([2, 4].indexOf(element.counterId) == -1 && tl.technicalcode == 'T08') {
                      _SpraAmcvParams.TechnicalId = tl.technicalid;
                      _SpraAmcvParams.CounterDesc = element.counterDesc;
                      this.SpraAmcvComponent?.SpraAmcvParams.push(_SpraAmcvParams);
                    }
                  }
                  }));
                }

              

                // last counter of for each loop -->> ADDED BY RAJAN SINGH ON 22 APRIL 2021 -->> AS CALCULATION NOT REFRESHING AFTER REMOVING PRODUCT
                if (index == CounterList.length-1) {
                  this.SetProductQtyToAmcv();
                  if (this.ProfitTag) {
                    this.SpraAmcvComponent?.CalculateTotalSaleValue()
                  }
                }

                index = index+1;
              }));
            }
          });
        }
      });
    }
    else {

      this.SpraApprovalComponent.SpraCsaRateArray = new Array<SpraCsaRate>();
      this.SpraApprovalComponent.IsSpraHaveCopMfd = this.opsPartSerachComponent.GetSpraHaveCopMfdTag();;
      this.SpraApprovalComponent.SpraApprovalParams.DayOneCSA = false;
      this.ChkDayOneCSA(this.SpraApprovalComponent.SpraApprovalParams,true);
      // this.SpraCompetitionDetailComponent.ResetCompCsaRate();
      if (this.SpraAmcvComponent != undefined) {
        this.SpraAmcvComponent.SpraAmcvParams = new Array<SpraAmcvParams>();
        if (this.ProfitTag) {
          this.SpraAmcvComponent.CalculateTotalSaleValue()
        }
      }


    }
  }

  UpdateExistingAMCVInCounter(spraAmcvParams: SpraAmcvParams, AmcvCounterWise: any[]) {
    spraAmcvParams.ExistingAMCV = Math.ceil(AmcvCounterWise.filter(acw => {
      return acw.CounterId == spraAmcvParams.CounterId
    })[0].AMCV);


  }


  FillSpraFromOps(OpsId: number) {
    this._OpsService.GetOpsDetailByOpsId(OpsId).subscribe((d: any) => {
      this.opsPartSerachComponent.ProductSearchParam.ProdSegmentId = d.prodSegmentId;
      this.opsPartSerachComponent.ProductSearchParam.AdvanceGroupId = d.advanceGroupId;

      // this.ContactBillingComponent.consigneeId = d.billingId;
      // this.ContactBillingComponent.changeConsigneeAddress();

      // this.ContactConsigneeComponent.consigneeId = d.consigneeId;
      // this.ContactConsigneeComponent.changeConsigneeAddress()
      // this.opsDetailsComponent.OpsDetailParams.DispatchWareHouseId = d.opsOtherDetails.dispatchWareHouseId;
      // this.opsDetailsComponent.OpsDetailParams.ExecutiveId = d.opsOtherDetails.executiveId;
      // this.opsDetailsComponent.OpsDetailParams.PoRefNo = d.opsOtherDetails.poNumber;
      // this.opsDetailsComponent.OpsDetailParams.PoDate = d.opsOtherDetails.poDate;
      this.opsPartSerachComponent.productArray = new Array<OpsProduct>();
      this.opsPartSerachComponent.Mode = "U";
      Promise.all(d.opsProductDetails.map((element: any, index: number) => {

        let opsProduct: OpsProduct = new OpsProduct()
        this.opsPartSerachComponent.ProductSearchParam.ProductCode = element.productCode.replace(/\s+$/g, '');
        this.opsPartSerachComponent.ProductSearchParam.ProductId = element.productId;
        opsProduct.Price = element.unitPrice;
        opsProduct.Quantity = element.quantity;

        this.opsPartSerachComponent.productArray.push(opsProduct);
        this.opsPartSerachComponent.BindProductAutocomplete(opsProduct, index);
        if (index == 0) {
          this.opsPartSerachComponent.ProductSearchParam.WarrantyMonth = element.warrantyMonth;
          this.ChangeOpsPartSerach(this.opsPartSerachComponent.ProductSearchParam);
        }

      }));


      this.OpsPaymentTermsComponent.PaymentTermParams.Term = d.paymentTerms.term;
      this.LinkedOps.OpsId = d.recordId
      this.LinkedOps.OpsNum = d.opsNum;
      this.LinkedOps.TempOpsNum = d.tempOpsNum;
      this.LinkedOps.OpsDate = d.opsDate;


      // this.OpsPaymentTermsComponent.PaymentTermParams.Amount = d.paymentTerms.amount;
      // this.OpsPaymentTermsComponent.PaymentTermParams.SlipNo = d.paymentTerms.slipNo;
      // this.OpsPaymentTermsComponent.PaymentTermParams.SlipDate = d.paymentTerms.slipDate;
      // this.OpsPaymentTermsComponent.PaymentTermParams.CreditDays = d.paymentTerms.creditDays;
      // this.OpsPaymentTermsComponent.PaymentTermParams.GeneralRemark = d.paymentTerms.generalRemark;
      // this.OpsPaymentTermsComponent.PaymentTermParams.BankGaurantee = d.paymentTerms.bankGaurantee;
      // this.OpsPaymentTermsComponent.PaymentTermParams.BGOnNationalBank = d.paymentTerms.bgOnNationalBank;

    });
  }


  async SpraSubmit() {
      /* 
          ===============Calling Sequence of functions============================================================================================

          ===============Profitability Calculation First=========================================================================================
          -- DisableSubmit - variable used to disable submit button on click  -- to restrict multiple click
          -- RecalculatePLDetail - to calculate all price and profitablility -  nested function calling inside this are given below with sequence
          1. this.SpraAmcvComponent.RecalculatePLDetail
          2. this.CalculateTotalSaleValue
          3. this.GetSPRAPriceListData
          4. this.CalculateGrandTotal
          5. this.GetAMCVTotalValues.emit(this.spraAmcvTotalValue); --->> After Profit calculation "InitializeSpraRequestModal" function calls to initialize submit process
          
          ===============Initialize submit process after Profitability Calculation ====================================================
          this.InitializeSpraRequestModal(); -- (This function is responsible for all validation and page model value initilization) 
          --  Functin used inside this are given below with execution sequence

          1. this.ValidateSpra() -- to Handle all form  validation -- If valid then next
          2. UploadDocuments() -->> If uploading any document then upload doscument api calls first otherwise
          3. this.InsertUploadSpra()  -->> Inside this , two api calls based on  (New SPRA request or Validating new SPRA)
              a. InsertSpraRequest -->> To create new SPRA request
              b. ValidationSPRA -->> TO approve or reject the SPRA request if validating the SPRA
         
         ============================XXXXXXXXX========================================================================================     
      */
    this.DisableSubmit  = true;

    //Added By Sagar Pandey On Date 10-09-2025 to prevent validation from duplicate screen if requet is already approved
    //"V" stands for spra Validation lIst SAS/SBS
    //"SAV" stands for SALES Admin ValidateList
    if(this.Mode =="U" && (this.PageFor == "V" || this.PageFor == "SAV") )
    {
      if(this.PageFor == "V")
      {
        await this.GetSpraValidationList()
      }
      else
      {
        await this.GetValidationListForAdminSales() //If Comming from Sales Admin Validate List
      }
     
      if(this.AlreadyApproved.length == 0)
      {
        let RedirectionPage: string = "spra-validationlist";
        if(!this.IsSalesAdmin && this.IsCeha  ){
          RedirectionPage = "spra-validationlist/1";
        }
        if (this.IsSalesAdmin && !this.IsCeha) { 
          RedirectionPage = "spra-adminsalesvalidate-list";
        }else if(this.IsSalesAdmin && this.IsCeha){
          RedirectionPage = "spra-adminsalesvalidate-list/1";
        }
        this.router.navigate([RedirectionPage], {
          state: {
            "Message": "Request Already Approved."
          }
        });
        return
      }
    }

    //added by rahul yadav on 09/05/2022m in case of request is reviewed
    // debugger
    if(this.IsRequestReviewed){
      this.InitializeSpraRequestReviewModal();
    }
    else{
      // debugger
      if(this.ProfitTag){
        this.RecalculatePLDetail();
        this.InitializeSpraRequestModal();  
      }else{
        this.InitializeSpraRequestModal();    
      }
    }
  }



  InitializeSpraRequestModal(){
    debugger;
    try{       
      this.IsSpraHaveFinishGood = this.opsPartSerachComponent.GetFinishedGoodsTag();
      this.SpraApprovalComponent.IsSpraHaveFinishGood = this.IsSpraHaveFinishGood;
      this.SpraApprovalComponent.ProdSegment = this.opsPartSerachComponent.ProductSearchParam.ProdSegmentId;
      if (this.ValidateSpra()) {
        this.SpraRequestDetail.ProdSegmentId = this.opsPartSerachComponent.ProductSearchParam.ProdSegmentId;
        this.SpraRequestDetail.AdvanceGroupId = parseInt(this.opsPartSerachComponent.AdvanceGroupId);
  
        let _PaymentTerm: PaymentTerm = new PaymentTerm();
        _PaymentTerm.Term = this.OpsPaymentTermsComponent.PaymentTermParams.Term;
        _PaymentTerm.CreditDays = this.OpsPaymentTermsComponent.PaymentTermParams.CreditDays;
        this.SpraRequestDetail.PaymentTerm = JSON.stringify(_PaymentTerm);
  
        this.SpraRequestDetail.EnteredBy = this.utility.user.employeeId;
        let _ProductDetails = new Array<OpsProductDetail>();
        
        Promise.all(this.opsPartSerachComponent.productArray.map(element => {
          if (element.SelectedProduct != undefined) {
            let _OpsProductDetail: OpsProductDetail = new OpsProductDetail();
            _OpsProductDetail.ProductId = element.SelectedProduct.productId;
            _OpsProductDetail.ProdMakeId = element.SelectedProduct.prodMakeId;
            _OpsProductDetail.ProdSegmentId = element.SelectedProduct.prodSegmentId;
            _OpsProductDetail.ProductGroupId = element.SelectedProduct.productGroupId;
            _OpsProductDetail.HsnCode = element.SelectedProduct.hsncode;
            _OpsProductDetail.GradeId = element.SelectedProduct.gradeId;
            _OpsProductDetail.UnitPrice = element.Price;
            _OpsProductDetail.Quantity = element.Quantity;
            // ADDED BY RAJAN SINGH ON 08 JUNE 2021 -->> TO SAVE VALUE FOR PRICE REFRENCE
            _OpsProductDetail.PriceList = element.PriceList != undefined ? element.PriceList:0;
            _OpsProductDetail.WorkSheetNSP = element.WorkSheetNSP != undefined ? element.WorkSheetNSP:0;
            _OpsProductDetail.WorkSheetLanded = element.WorkSheetLanded != undefined ? element.WorkSheetLanded:0;
            _OpsProductDetail.BookingLanded = element.BookingLanded != undefined ? element.BookingLanded:0;
            // _OpsProductDetail.UnitSalePrice = element.UnitSalePrice;
            // _OpsProductDetail.UnitWSCost = element.UnitWSCost;
            // _OpsProductDetail.SaleAmount = element.SaleAmount;
            _ProductDetails.push(_OpsProductDetail);
          }
        }));
  
        // for test
        // return false;
        
        if (this.ProfitTag){
          let _PriceRefCalculations:PriceRefCalculations = new PriceRefCalculations();
          _PriceRefCalculations.Product = this.opsPartSerachComponent.ProductProfitablity;
          if(this.SpraAmcvComponent != undefined){
            _PriceRefCalculations.AMCV = this.SpraAmcvComponent.AMCVProfitablity;
          }
          this.SpraRequestDetail.PriceRefCalculations  =JSON.stringify(_PriceRefCalculations);        
        }      
  
        this.SpraRequestDetail.ProductDetails = JSON.stringify(_ProductDetails);
        if (this.opsPartSerachComponent.spraConsigneeData.length > 0) {
          this.SpraRequestDetail.Consignee = JSON.stringify(this.opsPartSerachComponent.spraConsigneeData);          
        }
        this.SpraRequestDetail.OpsId = this.LinkedOps.OpsId;
        if (this.Mode != 'I') {
          this.SpraRequestDetail.OfficeId = this.utility.user.officeId;
        }
  
  
        this.SpraRequestDetail.PriceApproval = JSON.stringify(this.SpraApprovalComponent.SpraApprovalParams);
  
        if (this.SpraNetSalePriceRealisedComponent != undefined) {
          this.SpraRequestDetail.NetSalePriceRealised = JSON.stringify(this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams);
        }
  
        if (this.SpraCompetitionDetailComponent != undefined) {
          this.SpraRequestDetail.ComptDetail = JSON.stringify(this.SpraCompetitionDetailComponent.SPRACompetitionDetailArray.filter((t) => { return (t.CompName != undefined && t.CompName != "") }));
        }
  
        if (this.SpraAmcvComponent != undefined && this.SpraAmcvComponent.MachineLife != undefined && this.SpraAmcvComponent.SpraAmcvParams != undefined) {
          this.SpraRequestDetail.Amcv = JSON.stringify({
            "MachineLife": this.SpraAmcvComponent.MachineLife,
            "CounterDetail": this.SpraAmcvComponent.SpraAmcvParams
          })
        }
  
  
  
        if (this.Mode != "U") {
          if (this.SpraPriceJustificationComponent.SpraPriceJustificationParams.BoRemarks != undefined) {
            this.SpraRequestDetail.Remarks = this.SpraPriceJustificationComponent.SpraPriceJustificationParams.BoRemarks;
          }
        }
  
        if (this.SpraApprovalComponent != undefined && this.SpraApprovalComponent.SpraCsaRateArray.length > 0) {
          this.SpraRequestDetail.CsaRate = JSON.stringify(this.SpraApprovalComponent.SpraCsaRateArray);
        }
  
         //first uploading document -->> after upload document -->> InsertUploadSpra() will call to create SPRA
        this.UploadDocuments();
  
  
  
      }else{
        this.DisableSubmit  = false;
      }
    }
    catch(Error:any) {
      this.DisableSubmit  = false;
      console.log(Error.message);
    }finally{
      return true;          
    }
  }

  InsertUploadSpra() {
    if (this.Mode == "U") {

      let _SpraValidation: SpraValidation = new SpraValidation();
      _SpraValidation.SpraRequest = this.SpraRequestDetail;

      // this._TransactionService.UpdateSPRAData(this.SpraRequestDetail).subscribe((d):any =>{
      //   if(d){
      let Message: string;
      //  let Message:string = "SPRA ["+ d +"] updated"
      this.spraApprovalDetail.SpraRequestId = this.SPRAId;

      let spraApp: SpraApprovalRemarksParams;
      spraApp = this.SpraApprovalRemarksComponent.SpraApprovalRemarksParams.filter((item) => {
        return item.Tag == 0
      }
      )[0];

      if (spraApp.Remarks != undefined) {
        this.spraApprovalDetail.ValidateRemarks = spraApp.Remarks;
      }
      if (spraApp.AppStatus != undefined) {

        this.spraApprovalDetail.ApprovalStatus = spraApp.AppStatus;
      }
      this.spraApprovalDetail.ValidateBy = this.utility.user.employeeId;

      if (this.SpraApprovalRemarksComponent.IsSalesAdmin) {
        _SpraValidation.SpraRequest.ValidationRequired = JSON.stringify(this.SpraApprovalRemarksComponent.ValidationLevel
          .filter((vl) => { return vl.EmployeeId != undefined && vl.EmployeeId > 0 }));
      }

      _SpraValidation.SpraRequestApprovalValidation = this.spraApprovalDetail;

      let RedirectionPage: string = "spra-validationlist";
      if(!this.IsSalesAdmin && this.IsCeha  ){
        RedirectionPage = "spra-validationlist/1";
      }
      if (this.IsSalesAdmin && !this.IsCeha) { 
        RedirectionPage = "spra-adminsalesvalidate-list";
      }else if(this.IsSalesAdmin && this.IsCeha){
        RedirectionPage = "spra-adminsalesvalidate-list/1";
      }
  //added by rahul yadav for review on 06/5/2022
  
     if(this.spraApprovalDetail.ApprovalStatus=='V'){
      this._TransactionService.ReviewSPRA(_SpraValidation).subscribe((d): any => {
        if (d) {
          let Message: string = "SPRA request sent for Review successfully."

          this.router.navigate([RedirectionPage], {
            state: {
              "Message": Message
            }
          });
        } else {
          this._NotificationService.showError();
        }

      }, (error) => {
        this.utility.Error(error);
        this._NotificationService.showError();
        throw new Error('SPRA request not Reviewed.');
      });
     }else{
      
      this._TransactionService.ValidationSPRA(_SpraValidation).subscribe((d): any => {
        if (d) {
          let Message: string = "SPRA request validated successfully."

          this.router.navigate([RedirectionPage], {
            state: {
              "Message": Message
            }
          });
        } else {
          this._NotificationService.showError();
        }

      }, (error) => {
        this.utility.Error(error);
        this._NotificationService.showError();
        throw new Error('SPRA request not validated.');
      });

 
    }
    }
    //insertion
    else {
      this._TransactionService.InsertSpraRequest(this.SpraRequestDetail).subscribe((d): any => {
        if (d) {
          let Message: string = "SPRA Request [" + d + "] generated successfully."
          this.router.navigate(['search-customer'], {
            state: {
              "Message": Message
            }
          });
        } else {
          this._NotificationService.showError();
        }
      }, (error) => {
        this.utility.Error(error);
        this._NotificationService.showError();
        throw new Error('SPRA request not generated.');
      });
    }
  }


  ValidateSpra(): boolean {
  //for test  
  // console.log(this.opsPartSerachComponent.spraConsigneeData);
  // return false;

    if (!this.Validation()) {
      return false;
    } else if (!this.opsPartSerachComponent.Validation()) {
      return false;
    }
    else if (this.OpsPaymentTermsComponent != undefined && !this.OpsPaymentTermsComponent.Validation()) {
      return false;
    } else if (this.SpraApprovalComponent != undefined && !this.SpraApprovalComponent.Validation()) {
      return false;
    } else if (this.SpraAmcvComponent != undefined && !this.SpraAmcvComponent.Validation()) {
      return false;
    } else if (this.SpraNetSalePriceRealisedComponent != undefined && !this.SpraNetSalePriceRealisedComponent.Validation()) {
      return false;
    } else if (this.SpraCompetitionDetailComponent != undefined && !this.SpraCompetitionDetailComponent.Validation()) {
      return false;
    } else if (this.MultipleFileUploadComponent != undefined && !this.MultipleFileUploadComponent.Validation()) {
      return false;
    } else if (this.SpraPriceJustificationComponent != undefined && !this.SpraPriceJustificationComponent.Validation()) {
      return false;
    } else if (this.SpraApprovalRemarksComponent != undefined && !this.SpraApprovalRemarksComponent.Validation()) {
      return false;
    } else {
      return true;
    }

  }


  Validation(): boolean {
    if (!this.utility.CheckNumberRequired(this.SpraRequestDetail.Period)) {
      this._NotificationService.showError("Please enter SPRA period.", "SPRA Validity");
      return false
    }
    else {
      return true;
    }
  }



  GetSpraRequestData() {
    this._TransactionService.GetAllSPRARequestById(this.SPRAId).subscribe((d: any) => {
      this.SPRADetail = JSON.parse(d);
      //console.log(this.SPRADetail);
      this.BindSpraDetail();
    }, (error) => {                              //Error callback
      this.utility.Error(error);
    });

  }

  BindSpraDetail() {
    debugger;
    this.opsPartSerachComponent.ProductSearchParam.ProdSegmentId = this.SPRADetail.ProdSegmentId;
    this.opsPartSerachComponent.ProductSearchParam.AdvanceGroupId = this.SPRADetail.AdvanceGroupId;
    // TKT:56918 
    this.opsPartSerachComponent.AdvanceGroupId = this.SPRADetail.AdvanceGroupId.toString();
    this.opsPartSerachComponent.GradeId = this.SPRADetail.GradeId; //Added by rahul yadav on 12/7/2021
    this.SpraRequestDetail.SaleType = this.SPRADetail.SaleType;
    this.SpraRequestDetail.Period = this.SPRADetail.Period;
    this.SpraRequestDetail.OfficeId = this.SPRADetail.OfficeID;
    this.OnPeriodChange();
    this.OpsPaymentTermsComponent.PaymentTermParams = this.SPRADetail.PaymentTerm;
    this.OpsPaymentTermsComponent.PaymentTermParams.IsForSpra = true;
    this.SpraApprovalComponent.Mode = this.Mode;

    if (this.SPRADetail.Consignee != undefined) {
      this.opsPartSerachComponent.spraConsigneeData = this.SPRADetail.Consignee;
       //added by rahul yadav on 11/05/2022
       this.opsPartSerachComponent.ReviewedSpra = this.SPRADetail.ReviewedSpra;
       this.opsPartSerachComponent.IsDayOneCSAClick = this.SPRADetail.PriceApproval.DayOneCSA;    //Added By Jamaluddin Ansari on 21/08/2023 for getting DayOnCsa
       this.opsPartSerachComponent.IsRental = this.SPRADetail.IsRental;    //Added By Jamaluddin Ansari on 21/08/2023 for getting IsRental
    }



    this.MultipleFileUploadComponent.mode = this.Mode;

    this.MultipleFileUploadComponent.UploadFileData = new Array<UploadFileData>();
    let uploadFileData: UploadFileData = new UploadFileData();
    if (this.SPRADetail.Documents != undefined && this.SPRADetail.Documents.length > 0) {
      Promise.all(this.SPRADetail.Documents.map((element: any, index: number) => {
        let uploadFileData: UploadFileData = new UploadFileData()
        uploadFileData.Purpose = element.purpose;
        uploadFileData.IsNewRow = true;
        let file: File = new File([" "], element.purpose);
        uploadFileData.File = file;
        uploadFileData.disable = true;
        uploadFileData.DownloadFilePath = element.fileName;
        this.MultipleFileUploadComponent.UploadFileData.push(uploadFileData)
        if (index == this.SPRADetail.Documents.length - 1) {
          this.MultipleFileUploadComponent.addRow(uploadFileData, index);
        }
      }));
    } else {
      uploadFileData = new UploadFileData();
      this.MultipleFileUploadComponent.addRow(uploadFileData, 0);
    }

    if (this.SpraNetSalePriceRealisedComponent != undefined) {
      this.SpraNetSalePriceRealisedComponent.SaleType = this.SpraRequestDetail.SaleType;

    }
    if (this.SpraApprovalComponent != undefined) {
      this.SpraApprovalComponent.SaleType = this.SpraRequestDetail.SaleType;
      this.opsPartSerachComponent.SaleType = this.SpraRequestDetail.SaleType;

    }

    this.opsPartSerachComponent.productArray = new Array<OpsProduct>();
    this.opsPartSerachComponent.Mode = this.Mode;
    Promise.all(this.SPRADetail.ProdDetail.map((element: any, index: number) => {    
      let opsProduct: OpsProduct = new OpsProduct()
      this.opsPartSerachComponent.ProductSearchParam.ProductCode = element.ProductCode.replace(/\s+$/g, '');
      this.opsPartSerachComponent.ProductSearchParam.ProductId = element.ProductId;
      opsProduct.Price = element.UnitPrice;
      opsProduct.Quantity = element.Quantity;
      opsProduct.PriceList = element.PriceList;
      opsProduct.WorkSheetLanded = element.WorkSheetLanded;
      opsProduct.WorkSheetNSP = element.WorkSheetNSP;
      opsProduct.BookingLanded = element.BookingLanded;    
    opsProduct.IsNewRow = true;
      opsProduct.PId = element.ProductId;
      opsProduct.gID = element.Grade;
      opsProduct.pQty = element.Quantity;
      this.opsPartSerachComponent.productArray.push(opsProduct);
      this.opsPartSerachComponent.BindProductAutocomplete(opsProduct, index, true);





      if (index == this.SPRADetail.ProdDetail.length - 1) {
        this.opsPartSerachComponent.addRow(opsProduct);
        this.SpraApprovalComponent.BindWarrenty(this.SPRADetail.ProdSegmentId, this.SpraRequestDetail.SaleType, this.SPRADetail.PriceApproval.WarrantyMonth);
        setTimeout(() => {
          this.BindOtherComponentDetailAfterProduct();
        }, 1000)
        // this.opsPartSerachComponent.ProductSearchParam.WarrantyMonth = element.warrantyMonth;
        // this.ChangeOpsPartSerach(this.opsPartSerachComponent.ProductSearchParam);
      }



    }));
  }

  BindOtherComponentDetailAfterProduct(csaFlag:boolean = false) {
    debugger;
    setTimeout(() => {

      setTimeout(() => {
        if (this.SpraCompetitionDetailComponent != undefined) {
          this.SpraCompetitionDetailComponent.Mode = this.Mode;
          this.SpraCompetitionDetailComponent.SPRACompetitionDetailArray = this.SPRADetail.ComptDetail;
          this.SpraCompetitionDetailComponent.SPRACompetitionDetailArray.push(new SPRACompetitionDetailParams()); // to add new row

        }
        this.SpraApprovalComponent.IsSpraHaveFinishGood = this.opsPartSerachComponent.GetFinishedGoodsTag();
        this.opsPartSerachComponent.GetFinishedGoodsTotalPrice();
        this.SpraApprovalComponent.SpraApprovalParams = this.SPRADetail.PriceApproval;
        if (this.SPRADetail.Amcv != undefined) {
          this.SpraAmcvComponent.MachineLife = this.SPRADetail.Amcv.MachineLife;
          this.SpraAmcvComponent.SpraApprovalParams = this.SPRADetail.PriceApproval;
          this.SpraAmcvComponent.SaleType = this.SpraRequestDetail.SaleType;
        }
        if(!csaFlag){
          this.ChkDayOneCSA(this.SpraApprovalComponent.SpraApprovalParams);
        } 
      });



      // ADDED BY RAJAN SINGH ON 22 APR 2021 -->> TO SHOW SPRA NO AS PRICE REF --
      if (this.RefSpraDetail != undefined && this.RefSpraDetail.SpraId != undefined) {
        this.SpraApprovalComponent.SpraApprovalParams.PriceRef = this.RefSpraDetail.RequestNo;
      }
      if (this.SPRADetail.CsaRate != undefined) {
        this.SpraApprovalComponent.SpraCsaRateArray = this.SPRADetail.CsaRate;
      }
      if (this.SPRADetail.IsReviewRequest != undefined) {
        this.IsRequestReviewed = this.SPRADetail.IsReviewRequest;
        if(this.IsFromApprovedlist){
          this.IsRequestReviewed = true;
          this.opsPartSerachComponent.ReviewedSpra = true;
          this.MultipleFileUploadComponent.IsFromApprovedlist = true;
        }
      }
      //Added By rahul yadav on 28/05/2021 in case of priceref
      if (this.SPRADetail.SPRAPriceRefId != undefined) {
        this.SPRAPriceRefId = JSON.parse(this.SPRADetail.SPRAPriceRefId);

        this.SpraApprovalComponent.SPRAPriceRef.SPRAId = this.SPRAPriceRefId.PriceRefId;
        this.SpraApprovalComponent.SPRAPriceRef.OfficeId = this.SPRAPriceRefId.OfficeID;
        this.SpraApprovalComponent.SPRAPriceRef.CompanyId = this.SPRAPriceRefId.CompanyID;
        this.SpraApprovalComponent.SPRAPriceRef.Salecode = this.SPRAPriceRefId.SaleCode;
        this.SpraApprovalComponent.SPRAPriceRef.RefId = this.SPRAPriceRefId.RefId;

      }
      if (this.SpraApprovalRemarksComponent != undefined) {
        this.SpraApprovalRemarksComponent.SpraApprovalRemarksParams = this.SPRADetail.AppDetail;
        //added by rahul yadav on 06/05/2022 to show review radio button
        this.SpraApprovalRemarksComponent.ShowReviewButton = this.SPRADetail.ShowReviewButton;
        this.SpraApprovalRemarksComponent.IsFromApprovedlist = this.IsFromApprovedlist;
        if(this.SPRADetail.ParentSpraDetails!=undefined){
          this.SpraApprovalRemarksComponent.ParentSpraDetails = this.SPRADetail.ParentSpraDetails;
        }
        
      }

      //this.SPRADetail.ProfitTag = "Y";  // for testing only
      // alert(this.SPRADetail.ProfitTag);
      // this.Mode == 'I' // ADDED BY RAJAN SINGH ON 22 APRIL 2021 -- TO HANDLE COPY SPRA FUNCTIONALITY
      if (this.SPRADetail.ProfitTag == "N" || this.Mode == 'I') {
        this.ProfitTag = false;
      } else {
        this.ProfitTag = true;
      }
      this.opsPartSerachComponent.ProfitTag = this.ProfitTag;
      this.SpraApprovalComponent.ProfitTag = this.ProfitTag;
      if (this.SpraAmcvComponent != undefined) {
        this.SpraAmcvComponent.ProfitTag = this.ProfitTag;
      }



      let ArrDistance: Array<number>;
      ArrDistance = [];
      if (this.SPRADetail.DistanceID != undefined) {
        this.SPRADetail.DistanceID = JSON.parse(this.SPRADetail.DistanceID);
        //console.log(this.SPRADetail.DistanceID);
        Promise.all(this.SPRADetail.DistanceID.map((element: any) => {
          ArrDistance.push(element.DistanceID);
        }));
      }


      if (this.SpraAmcvComponent != undefined) {
        this.SpraAmcvComponent.DistanceID = ArrDistance;
        //console.log(this.SpraAmcvComponent.DistanceID);
        this.SpraAmcvComponent.spraCSARate = this.SPRADetail.CsaRate;
      }
      // else{
      //   this.SpraAmcvComponent.DistanceID=[];
      // }



      setTimeout(() => {
        if (this.SPRADetail.PriceApproval.DayOneCSA == true) {
          if (this.SpraAmcvComponent != undefined) {
            this.SpraAmcvComponent.SpraAmcvParams = this.SPRADetail.AMCV_CSA;
          }
          this.SpraApprovalComponent.IsSpraHaveCopMfd = this.opsPartSerachComponent.GetSpraHaveCopMfdTag();;
        }
        else if (this.SpraAmcvComponent != undefined && this.SPRADetail.AMCV_Product != undefined) {
          this.SpraAmcvComponent.SpraAmcvParams = this.SPRADetail.AMCV_Product;
        }

        //Added by rahul yadav on 30/05/2021 for consigneeDetails
        if (this.SpraViewConsigneeComponent != undefined && this.SPRADetail.ConsigneeDetails != undefined) {
        // setTimeout(() => {
          this.SpraViewConsigneeComponent.ConsineeDetails = this.SPRADetail.ConsigneeDetails;
        // }, 10);
      }

        if (this.opsPartSerachComponent.ProfitTag == true) {
          this.DiscountCalculation();
          
         // commented by Rajan Singh on 16 july 2021 ->> as PL Calculation function calling below and this function is calling in that
         // so, there were mulitple calling
          // this.opsPartSerachComponent.CalculateTotalValue();

        }
        Promise.all(this.SpraAmcvComponent?.SpraAmcvParams.map(item => {
          this.SpraAmcvComponent.BindProduct(item);

        }));

      }, 500)




      setTimeout(() => {
      
        if (this.SpraNetSalePriceRealisedComponent != undefined) {
          this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams = this.SPRADetail.NetSalePriceRealised;
          this.SpraNetSalePriceRealisedComponent.DealerParam.OfficeId = this.SpraRequestDetail.OfficeId;
          this.SpraNetSalePriceRealisedComponent.BindDealerList(this.SPRADetail.NetSalePriceRealised.PartnerId);
          if (this.SPRADetail.NetSalePriceRealised.PartnerId > 0) {
            this.PartnerId = this.SPRADetail.NetSalePriceRealised.PartnerId;
            this.DealerChange(this.SPRADetail.NetSalePriceRealised.PartnerId);
          }
        }
        this.DealerChange(this.PartnerId);
        
      // this.GetExistingCsaRate();
      // if (this.SpraAmcvComponent != undefined && this.SpraAmcvComponent.ProfitTag == true) {
      //   this.SpraAmcvComponent.CalculateTotalSaleValue();
      // }
      //added by swati on 19/05/2021 to calculate total discount
      this.RecalculatePLDetail();
      
        
      
      //end of addition by swati

      }, 1000);



    });

  }

  DiscountCalculation() {
    this.opsPartSerachComponent.ProductProfitablity.TotDiscount = 0;
    if (this.SPRADetail.NetSalePriceRealised?.FreeItem != undefined) {
      this.opsPartSerachComponent.ProductProfitablity.TotDiscount = this.opsPartSerachComponent.ProductProfitablity.TotDiscount + Number(this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.FreeItem);
    }
    if (this.SPRADetail.NetSalePriceRealised?.AgentCommission != undefined) {
      this.opsPartSerachComponent.ProductProfitablity.TotDiscount = this.opsPartSerachComponent.ProductProfitablity.TotDiscount + Number(this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.AgentCommission);
    }
    if (this.SPRADetail.NetSalePriceRealised?.InstallationCommission != undefined) {
      this.opsPartSerachComponent.ProductProfitablity.TotDiscount = this.opsPartSerachComponent.ProductProfitablity.TotDiscount + Number(this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.InstallationCommission);
    }
    if (this.SPRADetail.NetSalePriceRealised?.OtherDiscount != undefined) {
      this.opsPartSerachComponent.ProductProfitablity.TotDiscount = this.opsPartSerachComponent.ProductProfitablity.TotDiscount + Number(this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.OtherDiscount);
    }
    if (this.SPRADetail.NetSalePriceRealised?.DealerCommission != undefined) {
      this.opsPartSerachComponent.ProductProfitablity.TotDiscount = this.opsPartSerachComponent.ProductProfitablity.TotDiscount + Number(this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.DealerCommission);
    }
    if (this.SPRADetail.NetSalePriceRealised?.ReSaleValueBuyBack != undefined) {
      this.opsPartSerachComponent.ProductProfitablity.TotDiscount = this.opsPartSerachComponent.ProductProfitablity.TotDiscount - Number(this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.ReSaleValueBuyBack);
    }
    if (this.SPRADetail.NetSalePriceRealised?.RebateWoGST != undefined) {
      this.opsPartSerachComponent.ProductProfitablity.TotDiscount = this.opsPartSerachComponent.ProductProfitablity.TotDiscount + Number(this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.RebateWoGST);
    }
    if (this.SPRADetail.NetSalePriceRealised?.BuyBack != undefined) {
      this.opsPartSerachComponent.ProductProfitablity.TotDiscount = this.opsPartSerachComponent.ProductProfitablity.TotDiscount + Number(this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.BuyBack);
    }
    // ADDED BY RAJAN SINGH ON 15 JULY 2021 -->> AS MAILED BY MR ANAND BOUGHT OUT ITEM NOT REFLECTING IN DISCOUNT VALUE
    if (this.SPRADetail.NetSalePriceRealised?.BoughtOutItems != undefined) {
      this.opsPartSerachComponent.ProductProfitablity.TotDiscount = this.opsPartSerachComponent.ProductProfitablity.TotDiscount + Number(this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.BoughtOutItems);
    }

    // added by RAJAN SINGH ON 06 AUG 2021 -->> TKT:56668
    if ( this.SpraApprovalComponent != undefined && this.SpraApprovalComponent.SpraApprovalParams.WarrentyCost != undefined) {
      this.opsPartSerachComponent.ProductProfitablity.TotDiscount = this.opsPartSerachComponent.ProductProfitablity.TotDiscount + Number(this.SpraApprovalComponent.SpraApprovalParams.WarrentyCost);
    }

    if (this.opsPartSerachComponent.ProductProfitablity.TotDiscount != 0) {
      this.opsPartSerachComponent.ProductProfitablity.TotDiscount = -1 * this.opsPartSerachComponent.ProductProfitablity.TotDiscount;
    }

  }

  OnPeriodChange() {
    // Sales Admin Onwards
    // if(this.ProfitTag){
    if (this.utility.CheckNumberRequired(this.SpraRequestDetail.Period)) {
      this.ValidTill = this.utility.AddDays(new Date(), this.SpraRequestDetail.Period);
      this.SpraRequestDetail.ValidTill = this.utility.AddDays(new Date(), this.SpraRequestDetail.Period, "ForApi");
    }
    // }
  }


  GetExistingCsaRate() {
    this._MasterService.GetExistingCsaRate(this.SpraRequestDetail.RefId).subscribe((d: any) => {
      if (d && d != "") {
        this.ExistingCsaRate = JSON.parse(d);
        Promise.all(this.SpraApprovalComponent.SpraCsaRateArray.map(e => {
          let ExistingCsaRate: any[] = this.ExistingCsaRate.filter(ec => e.CounterId == ec.CounterId)
          if (ExistingCsaRate != undefined && ExistingCsaRate.length > 0) {
            e.ExistingCSARate = ExistingCsaRate[0].Rate;
          }
        }));
      }
    });

  }



  // PriceRefSelected(RefSpraDetail:any){
  //   if (RefSpraDetail != undefined && RefSpraDetail.SpraId != undefined){
  //     this.SPRAId = RefSpraDetail.SpraId
  //     this.RefSpraDetail= RefSpraDetail;
  //     this.GetSpraRequestData();
  //     this.SpraApprovalComponent.SpraApprovalParams.PriceRef = RefSpraDetail.RequestNo;
  //   }

  // }


  BindSpraEnquiryDetail() {
    if (this.SpraRequestDetail.OpportunityId != undefined) {
      this._TransactionService.GetSpraEnquireyDetailById(this.SpraRequestDetail.OpportunityId).subscribe((d: any) => {

        this.SPRADetail = JSON.parse(d);


        this.opsPartSerachComponent.ProductSearchParam.ProdSegmentId = this.SPRADetail.ProdSegmentId;
        this.opsPartSerachComponent.ProductSearchParam.AdvanceGroupId = this.SPRADetail.AdvanceGroupId;
        this.OpsPaymentTermsComponent.PaymentTermParams.IsForSpra = true;        
        this.SpraApprovalComponent.Mode = this.Mode;


        this.opsPartSerachComponent.productArray = new Array<OpsProduct>();
        this.opsPartSerachComponent.Mode = this.Mode;
        Promise.all(this.SPRADetail.ProdDetail.map((element: any, index: number) => {
          let opsProduct: OpsProduct = new OpsProduct()
          this.opsPartSerachComponent.ProductSearchParam.ProductCode = element.ProductCode.replace(/\s+$/g, '');
          this.opsPartSerachComponent.ProductSearchParam.ProductId = element.ProductId;
          opsProduct.Price = element.UnitPrice;
          opsProduct.Quantity = element.Quantity;
          opsProduct.IsNewRow = true;
          this.opsPartSerachComponent.productArray.push(opsProduct);
          this.opsPartSerachComponent.BindProductAutocomplete(opsProduct, index, true);




          if (index == this.SPRADetail.ProdDetail.length - 1) {
            this.opsPartSerachComponent.addRow(opsProduct);
            setTimeout(() => {
              this.IsSpraHaveFinishGood = this.opsPartSerachComponent.GetFinishedGoodsTag();
              if(this.SpraCompetitionDetailComponent != undefined){
                this.SpraCompetitionDetailComponent.Mode = this.Mode;                
                this.SpraApprovalComponent.BindWarrenty(this.SPRADetail.ProdSegmentId, this.SpraRequestDetail.SaleType, 0);
                }
                //added by rahul yadav on 24/06/2021 amcv component not showing
                this.ChangeOpsPartSerach(this.opsPartSerachComponent.ProductSearchParam);
            }, 1000)
            

          }



        }));

      }, (error) => {                              //Error callback
        this.utility.Error(error);
      });
    }

  }




  //========================================Commented By Sagar Pandey Because asynchronus is causing issue in uploading file name in database
  //============= create an updated funtion below this Please Check Date:13-12-2023===========================//
  //#starts here
  /*
  async UploadDocuments(): Promise<void> {
    debugger;
    let UploadFileName: any[] = [];
    if (this.MultipleFileUploadComponent.UploadFileData != undefined) {

      // Filtering Upload file aaray for which file needs to be upload
      let dtUploadedFiles: UploadFileData[] = this.MultipleFileUploadComponent.UploadFileData.filter((ft) => { return ft.File != undefined && ft.disable == false });

      // If PAGE IS IN VALIDATION MODE -->> FILTERING ALREDAY UPLOADED FILE DATA
      await Promise.all(this.MultipleFileUploadComponent.UploadFileData.filter((ft) => { return ft.DownloadFilePath != "" }).map((t, index) => {
        UploadFileName.push({ "fileName": t.DownloadFilePath, "purpose": t.Purpose });
      }));


      if (dtUploadedFiles.length > 0) {
        for (let i = 0; i < dtUploadedFiles.length; i++) {
          let uploadFileData: UploadFileData = dtUploadedFiles[i];
          if (uploadFileData.File != undefined) {
            let progressInfoObj = { "value": 0, "fileName": uploadFileData.File.name };
            this.MultipleFileUploadComponent.progressInfos.push(progressInfoObj);
            this.uploadService.upload(uploadFileData).subscribe(
              event => {
                if (event) {
                  let dt: any = event;
                  if (dt.body != undefined) {
                    UploadFileName.push({ "fileName": dt.body.fileName, "purpose": dt.body.purpose });
                    // ON LAST FILE UPLOAD -- ASSGINIG DOCUMENTS JSON TO SPRA REQUEST OBJECT -->> AND CALLING SPRA CREATION METHOD
                    // if (i == dtUploadedFiles.length - 1) {
                    //   this.SpraRequestDetail.Documents = JSON.stringify(UploadFileName);
                    //   this.InsertUploadSpra();
                    // }
                  }
                  if (event.type === HttpEventType.UploadProgress && event.total != undefined) {
                    this.MultipleFileUploadComponent.progressInfos[i].value = Math.round(100 * event.loaded / event.total);
                  }
                }


              },
              err => {                
                this.MultipleFileUploadComponent.progressInfos[i].value = 0;
                throw new Error('Unable to upload document.');
              });

          }

        }
        debugger;
        this.SpraRequestDetail.Documents = JSON.stringify(UploadFileName);
        this.InsertUploadSpra();

      } else {
        this.SpraRequestDetail.Documents = JSON.stringify(UploadFileName);
        this.InsertUploadSpra();
      }

    }
  }
  */
  //#Ends Here


 
//The Above is Modified and This is the New Version with proper handling of asynchronus (used Observable and fork join)
//Added sagar Pandey on 13-12-2023
//#Starts Here
async UploadDocuments(): Promise<void> {
  debugger;
  let UploadFileName: any[] = [];
  if (this.MultipleFileUploadComponent.UploadFileData != undefined) {
    // Filtering Upload file array for files that need to be uploaded
    let dtUploadedFiles: UploadFileData[] = this.MultipleFileUploadComponent.UploadFileData.filter((ft) => ft.File != undefined && ft.disable == false);

    // If PAGE IS IN VALIDATION MODE -->> FILTERING ALREADY UPLOADED FILE DATA
    await Promise.all(this.MultipleFileUploadComponent.UploadFileData.filter((ft) => ft.DownloadFilePath != "").map((t, index) => {
      UploadFileName.push({ "fileName": t.DownloadFilePath, "purpose": t.Purpose });
    }));

    if (dtUploadedFiles.length > 0) {
      // Create an array to store observables for each upload
      let uploadObservables: Observable<any>[] = dtUploadedFiles.map(uploadFileData => {
        if (uploadFileData.File != undefined) {
          let progressInfoObj = { "value": 0, "fileName": uploadFileData.File.name };
          this.MultipleFileUploadComponent.progressInfos.push(progressInfoObj);
          return this.uploadService.upload(uploadFileData);
        }
        // Add a default return value if the condition above is not met
        return of(null);
      });
      

      // Use forkJoin to wait for all uploads to complete
      forkJoin(uploadObservables).subscribe(
        (events:any) => {
          events.forEach((event:any, i:any) => {
            if (event) {
              let dt: any = event;
              if (dt.body != undefined) {
                UploadFileName.push({ "fileName": dt.body.fileName, "purpose": dt.body.purpose });
              }
              if (event.type === HttpEventType.UploadProgress && event.total != undefined) {
                this.MultipleFileUploadComponent.progressInfos[i].value = Math.round(100 * event.loaded / event.total);
              }
            }
          });

          // All uploads completed, now update SpraRequestDetail.Documents and call InsertUploadSpra
          this.SpraRequestDetail.Documents = JSON.stringify(UploadFileName);
          this.InsertUploadSpra();
        },
        err => {
          // Handle error
          throw new Error('Unable to upload document.');
        }
      );
    } else {
      this.SpraRequestDetail.Documents = JSON.stringify(UploadFileName);
      this.InsertUploadSpra();
    }
  }
}
//Ends Here

  SpraHaveFinishGood(IsSpraHaveFinishGood: boolean) {
    this.IsSpraHaveFinishGood = IsSpraHaveFinishGood;
    this.SpraApprovalComponent.IsSpraHaveFinishGood = this.IsSpraHaveFinishGood;
    this.SpraApprovalComponent.IsSpraHaveCopMfd = this.opsPartSerachComponent.GetSpraHaveCopMfdTag();

  }

  DealerChange(PartnerId: number) {
    if (this.SpraConsumableBillingDetailComponent != undefined)
      this.SpraConsumableBillingDetailComponent.GetDealerConsumableBillingDetail(PartnerId);
  }


  RecalculatePLDetail()
  {

     this.DiscountCalculation();     
     this.opsPartSerachComponent.CalculateTotalValue();
    
   //----------------------change the execution order of bot timeout --------------------//  
     setTimeout(() => {      
      // this.opsPartSerachComponent.CalcFGServTotAmount();
      this.SpraAmcvComponent.RecalculatePLDetail(); // added by rajan singh on 15 july 2021 as in validation mode only one was calling and frofitability value was fluctuating 
       this.DiscountView();       
     },1000);
     
    //  commented by rajan singh on 23 june 2021 as this reinitializing  profitabilit to zero
    //  setTimeout(() => {
      // if (this.SpraAmcvComponent != undefined && this.SpraAmcvComponent.ProfitTag == true) {
      //   this.SpraAmcvComponent.CalculateTotalSaleValue();
      // }
    // }, 3000);
    //-----------------------------Ended--------------//

  }

  DiscountView() {
    if (this.SpraDiscountViewComponent != undefined) {
      let _DiscountView: DiscountView = new DiscountView();
      if (this.opsPartSerachComponent.ProductProfitablity.TotalSaleValue != undefined) {
        _DiscountView.TotalPurOrderVal = this.opsPartSerachComponent.ProductProfitablity.TotalSaleValue - this.opsPartSerachComponent.ProductProfitablity.TotDiscount;
      }
      if (this.SpraApprovalComponent.SpraApprovalParams.WarrentyCost != undefined) {
        _DiscountView.warrantycost = Number(this.SpraApprovalComponent.SpraApprovalParams.WarrentyCost);
      }
      if (this.SpraNetSalePriceRealisedComponent != undefined) {
        if (this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.DealerCommission != undefined || this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.AgentCommission != undefined) {
          _DiscountView.DealerComm = this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.DealerCommission ? this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.DealerCommission : this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.AgentCommission;
        }
        if (this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.BuyBack != undefined) {
          _DiscountView.BuyBack = this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.BuyBack;
        }
        if (this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.ReSaleValueBuyBack != undefined) {
          _DiscountView.ResaleBuyBackVal = this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.ReSaleValueBuyBack;
        }
        if (this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.InstallationCommission != undefined) {
          _DiscountView.InstallComm = this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.InstallationCommission;
        }
        if (this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.BoughtOutItems != undefined) {
          _DiscountView.BoughtOutItmes = this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.BoughtOutItems;
        }
        if (this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.RebateWoGST != undefined) {
          _DiscountView.RebatewoGST = this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams.RebateWoGST;
        }
      }
      _DiscountView.NetSalePriceRealised = (_DiscountView.TotalPurOrderVal - _DiscountView.warrantycost - _DiscountView.DealerComm - _DiscountView.BuyBack - _DiscountView.InstallComm - _DiscountView.BoughtOutItmes - _DiscountView.RebatewoGST) + _DiscountView.ResaleBuyBackVal;

      this.SpraDiscountViewComponent.SpraDiscountView = _DiscountView;
    }

    // setTimeout(() => {
    //   this.utility.BlockUIStop();
    // }, 500);
  }


  // SpraAmcvParams

  BindCsaUnitPrice(spraAmcvParams:SpraAmcvParams){
    if (this.SpraApprovalComponent.SpraApprovalParams.DayOneCSA) {      
      Promise.all(this.SpraApprovalComponent?.SpraCsaRateArray.map((sc) => { 
        if(sc.CounterId == spraAmcvParams.CounterId ){
          if(spraAmcvParams.TotalCopy != undefined){
            //Added by Rahul Kumar on 29/07/2022 [made changes  in spra-amcv component to avoid random values.]
            sc.PriceList = spraAmcvParams.PriceList / spraAmcvParams.TotalCopy;
            sc.WorkSheetLanded = spraAmcvParams.WorkSheetLanded / spraAmcvParams.TotalCopy;  
          }
          else
          {
            sc.PriceList = spraAmcvParams.PriceList;
            sc.WorkSheetLanded = spraAmcvParams.WorkSheetLanded;  
          }
          if (sc.OrderRate != undefined && (sc.OrderRate - sc.WorkSheetLanded)!=0){
            // CHANGES BY RAJAN SINGH ON 15 JULY 2021 -->> FORMULA CHANGE REQUEST BY MR. ANAND AND CALCULATION SHARED BY HIM ON MAIL
            // sc.GP = this.utility.RoundOff(((sc.OrderRate - sc.WorkSheetLanded)/sc.WorkSheetLanded)*100);
            sc.GP = this.utility.RoundOff(((sc.OrderRate - sc.WorkSheetLanded)/sc.OrderRate)*100);
          }else{
            sc.GP = 0;
          }
        }
      }));
    }
  }
  
 //below code added by rahul yadav on 09/05/2022 for reviewed Spra
  InitializeSpraRequestReviewModal(){
    try{      
    
      this.IsSpraHaveFinishGood = this.opsPartSerachComponent.GetFinishedGoodsTag();
      this.SpraApprovalComponent.IsSpraHaveFinishGood = this.IsSpraHaveFinishGood;
      this.SpraApprovalComponent.ProdSegment = this.opsPartSerachComponent.ProductSearchParam.ProdSegmentId;
      if (this.ValidateSpra()) {
        this.SpraRequestDetail.ProdSegmentId = this.opsPartSerachComponent.ProductSearchParam.ProdSegmentId;
        this.SpraRequestDetail.AdvanceGroupId = parseInt(this.opsPartSerachComponent.AdvanceGroupId);
  
        let _PaymentTerm: PaymentTerm = new PaymentTerm();
        _PaymentTerm.Term = this.OpsPaymentTermsComponent.PaymentTermParams.Term;
        _PaymentTerm.CreditDays = this.OpsPaymentTermsComponent.PaymentTermParams.CreditDays;
        this.SpraRequestDetail.PaymentTerm = JSON.stringify(_PaymentTerm);
  
        this.SpraRequestDetail.EnteredBy = this.utility.user.employeeId;
        let _ProductDetails = new Array<OpsProductDetail>();
        Promise.all(this.opsPartSerachComponent.productArray.map(element => {
          if (element.SelectedProduct != undefined) {
            let _OpsProductDetail: OpsProductDetail = new OpsProductDetail();
            _OpsProductDetail.ProductId = element.SelectedProduct.productId;
            _OpsProductDetail.ProdMakeId = element.SelectedProduct.prodMakeId;
            _OpsProductDetail.ProdSegmentId = element.SelectedProduct.prodSegmentId;
            _OpsProductDetail.ProductGroupId = element.SelectedProduct.productGroupId;
            _OpsProductDetail.HsnCode = element.SelectedProduct.hsncode;
            _OpsProductDetail.GradeId = element.SelectedProduct.gradeId;
            _OpsProductDetail.UnitPrice = element.Price;
            _OpsProductDetail.Quantity = element.Quantity;
            // ADDED BY RAJAN SINGH ON 08 JUNE 2021 -->> TO SAVE VALUE FOR PRICE REFRENCE
            _OpsProductDetail.PriceList = element.PriceList != undefined ? element.PriceList:0;
            _OpsProductDetail.WorkSheetNSP = element.WorkSheetNSP != undefined ? element.WorkSheetNSP:0;
            _OpsProductDetail.WorkSheetLanded = element.WorkSheetLanded != undefined ? element.WorkSheetLanded:0;
            _OpsProductDetail.BookingLanded = element.BookingLanded != undefined ? element.BookingLanded:0;
            // _OpsProductDetail.UnitSalePrice = element.UnitSalePrice;
            // _OpsProductDetail.UnitWSCost = element.UnitWSCost;
            // _OpsProductDetail.SaleAmount = element.SaleAmount;
            _ProductDetails.push(_OpsProductDetail);
          }
        }));
  
        // for test
        // return false;
        
        if (this.ProfitTag){
          let _PriceRefCalculations:PriceRefCalculations = new PriceRefCalculations();
          _PriceRefCalculations.Product = this.opsPartSerachComponent.ProductProfitablity;
          if(this.SpraAmcvComponent != undefined){
            _PriceRefCalculations.AMCV = this.SpraAmcvComponent.AMCVProfitablity;
          }
          this.SpraRequestDetail.PriceRefCalculations  =JSON.stringify(_PriceRefCalculations);        
        }      
  
        this.SpraRequestDetail.ProductDetails = JSON.stringify(_ProductDetails);
        if (this.opsPartSerachComponent.spraConsigneeData.length > 0) {
          this.SpraRequestDetail.Consignee = JSON.stringify(this.opsPartSerachComponent.spraConsigneeData);          
        }
        this.SpraRequestDetail.OpsId = this.LinkedOps.OpsId;
        if (this.Mode != 'I') {
          this.SpraRequestDetail.OfficeId = this.utility.user.officeId;
        }
  
  
        this.SpraRequestDetail.PriceApproval = JSON.stringify(this.SpraApprovalComponent.SpraApprovalParams);
  
        if (this.SpraNetSalePriceRealisedComponent != undefined) {
          this.SpraRequestDetail.NetSalePriceRealised = JSON.stringify(this.SpraNetSalePriceRealisedComponent.SpraNetSalePriceRealisedParams);
        }
  
        if (this.SpraCompetitionDetailComponent != undefined) {
          this.SpraRequestDetail.ComptDetail = JSON.stringify(this.SpraCompetitionDetailComponent.SPRACompetitionDetailArray.filter((t) => { return (t.CompName != undefined && t.CompName != "") }));
        }
  
        if (this.SpraAmcvComponent != undefined && this.SpraAmcvComponent.MachineLife != undefined && this.SpraAmcvComponent.SpraAmcvParams != undefined) {
          this.SpraRequestDetail.Amcv = JSON.stringify({
            "MachineLife": this.SpraAmcvComponent.MachineLife,
            "CounterDetail": this.SpraAmcvComponent.SpraAmcvParams
          })
        }
  
  
  
        if (this.Mode != "U") {
          if (this.SpraPriceJustificationComponent.SpraPriceJustificationParams.BoRemarks != undefined) {
            this.SpraRequestDetail.Remarks = this.SpraPriceJustificationComponent.SpraPriceJustificationParams.BoRemarks;
          }
        }
  
        if (this.SpraApprovalComponent != undefined && this.SpraApprovalComponent.SpraCsaRateArray.length > 0) {
          this.SpraRequestDetail.CsaRate = JSON.stringify(this.SpraApprovalComponent.SpraCsaRateArray);
        }
  
         //first uploading document -->> after upload document -->> InsertUploadSpra() will call to create SPRA
        this.UploadReviewDocuments();
  
  
  
      }else{
        this.DisableSubmit  = false;
      }
  }
    catch(Error:any) {
      this.DisableSubmit  = false;
      console.log(Error.message);
    }finally{
      return true;          
    }
  }

  async UploadReviewDocuments(): Promise<void> {
    debugger
    let UploadFileName: any[] = [];
    if (this.MultipleFileUploadComponent.UploadFileData != undefined) {
      //  debugger
      // Filtering Upload file aaray for which file needs to be upload
      let dtUploadedFiles: UploadFileData[] = this.MultipleFileUploadComponent.UploadFileData.filter((ft) => { return ft.File != undefined && ft.disable == false });
      // let dtUploadedFiles: UploadFileData[] = this.MultipleFileUploadComponent.UploadFileData.filter((ft) => { return ft.File != undefined});

      //If PAGE IS IN VALIDATION MODE -->> FILTERING ALREDAY UPLOADED FILE DATA
      await Promise.all(this.MultipleFileUploadComponent.UploadFileData.filter((ft) => { return ft.DownloadFilePath != "" }).map((t, index) => {
        UploadFileName.push({ "fileName": t.DownloadFilePath, "purpose": t.Purpose });
      }));


      if (dtUploadedFiles.length > 0) {
        // debugger
        for (let i = 0; i < dtUploadedFiles.length; i++) {
          let uploadFileData: UploadFileData = dtUploadedFiles[i];
          if (uploadFileData.File != undefined) {
            // let _fileName="";
            // if(uploadFileData.DownloadFilePath !=""){
            //   uploadFileData = uploadFileData.DownloadFilePath
            // }
            let progressInfoObj = { "value": 0, "fileName": uploadFileData.File.name };
            this.MultipleFileUploadComponent.progressInfos.push(progressInfoObj);
            await this.uploadService.uploadReview(uploadFileData).toPromise().then(
              event => {
                // setTimeout(() => {
                if (event) {
                  let dt: any = event;
                  if (dt.body != undefined) {
                    UploadFileName.push({ "fileName": dt.body.fileName, "purpose": dt.body.purpose });
                    // ON LAST FILE UPLOAD -- ASSGINIG DOCUMENTS JSON TO SPRA REQUEST OBJECT -->> AND CALLING SPRA CREATION METHOD
                    //COMMENTED BY JAMALUDDIN ANSARI ON 23/08/2023
                    // if (i == dtUploadedFiles.length - 1) {
                    //   // console.log(UploadFileName);
                    //   debugger;
                    //   this.SpraRequestDetail.Documents = JSON.stringify(UploadFileName);
                    //   debugger;
                    //     this.InsertUploadReviewSpra();


                    // }
                  }
                  if (event.type === HttpEventType.UploadProgress && event.total != undefined) {
                    this.MultipleFileUploadComponent.progressInfos[i].value = Math.round(100 * event.loaded / event.total);
                  }
                  // }}, 500);
                }
              },
              err => {
                this.MultipleFileUploadComponent.progressInfos[i].value = 0;
                throw new Error('Unable to upload document.');
              });

          }

        }
        debugger;
        this.SpraRequestDetail.Documents = JSON.stringify(UploadFileName);
        this.InsertUploadReviewSpra();


      }
      else {
        this.SpraRequestDetail.Documents = JSON.stringify(UploadFileName);
        this.InsertUploadReviewSpra();
      }

    }
  }
  InsertUploadReviewSpra() {
   // if (this.Mode == "U") {
// debugger
      let _SpraValidation: SpraValidation = new SpraValidation();
        //added by rahul yadav on 09/05/2022 for parent spra id
       
      this.SpraRequestDetail.Id = 0;
      this.SpraRequestDetail.ParentSpraId = this.SPRAId;
      this.SpraRequestDetail.RequestNo = this.SPRADetail.RequestNo;
      this.SpraRequestDetail.OfficeId = this.SPRADetail.OfficeID;
      this.SpraRequestDetail.EnteredBy = this.SPRADetail.EnteredById;
      this.SpraRequestDetail.OpportunityId = this.SPRADetail?.OpportunityId;
      this.SpraRequestDetail.Remarks = this.SPRADetail.Remarks;
      //this.SpraRequestDetail.Documents = Documents;

      //_SpraValidation.SpraRequest.Documents="";
      _SpraValidation.SpraRequest = this.SpraRequestDetail;
     // _SpraValidation.SpraRequest.Documents=Documents;
      // console.log(_SpraValidation.SpraRequest.Documents);
      // this._TransactionService.UpdateSPRAData(this.SpraRequestDetail).subscribe((d):any =>{
      //   if(d){
      let Message: string;
      //  let Message:string = "SPRA ["+ d +"] updated"
      this.spraApprovalDetail.SpraRequestId = this.SPRAId;

      let spraApp: SpraApprovalRemarksParams;
      spraApp = this.SpraApprovalRemarksComponent.SpraApprovalRemarksParams.filter((item) => {
        return item.Tag == 0
      }
      )[0];

      if (spraApp.Remarks != undefined) {
        this.spraApprovalDetail.ValidateRemarks = spraApp.Remarks;
      }
      if (spraApp.AppStatus != undefined) {

        this.spraApprovalDetail.ApprovalStatus = spraApp.AppStatus;
      }
      this.spraApprovalDetail.ValidateBy = this.utility.user.employeeId;

      if (this.SpraApprovalRemarksComponent.IsSalesAdmin) {
        _SpraValidation.SpraRequest.ValidationRequired = JSON.stringify(this.SpraApprovalRemarksComponent.ValidationLevel
          .filter((vl) => { return vl.EmployeeId != undefined && vl.EmployeeId > 0 }));
      }

      _SpraValidation.SpraRequestApprovalValidation = this.spraApprovalDetail;

      let RedirectionPage: string = "spra-salesadminreview-list";
      if(this.IsCeha && !this.IsFromApprovedlist){
        RedirectionPage = "spra-salesadminreview-list/1";
      }
      if(!this.IsCeha && this.IsFromApprovedlist){
        RedirectionPage = "spra-salesadminapprev-list";
      }
      if(this.IsCeha && this.IsFromApprovedlist){
        RedirectionPage = "spra-salesadminapprev-list/1";
      }
      // if (this.IsSalesAdmin && !this.IsCeha) { 
      //   RedirectionPage = "spra-adminsalesvalidate-list";
      // }else if(this.IsSalesAdmin && this.IsCeha){
      //   RedirectionPage = "spra-adminsalesvalidate-list/1";
      // }

      this._TransactionService.InsertSpraReviewRequest(_SpraValidation).subscribe((d): any => {
        if (d) {
          let Message: string = "SPRA Request [" + d + "] generated successfully."
          if(d=="false"){
            Message ="Ops already created for this SPRA!";
           // this._NotificationService.showWarning("Ops already created for this SPRA!","");
            // return false;
          }
          this.router.navigate([RedirectionPage], {
            state: {
              "Message": Message
            }
          });
        } else {
          this._NotificationService.showError();
        }
      }, (error) => {
        this.utility.Error(error);
        this._NotificationService.showError();
        throw new Error('SPRA request not generated.');
      });
    
  }


}





